import { makeEntityScaffold } from '@classpass/saga-tools';
var KEY = 'SAGA.API.PAGES';
export var pageContentByKey = makeEntityScaffold("".concat(KEY, ".CONTENT"), function (client, key) {
  return client.pages.getPageByKey(key).then(function (resp) {
    return resp.data;
  });
});
export var pageIndexByKey = makeEntityScaffold("".concat(KEY, ".INDEX"), function (client, key) {
  return client.pages.getPageByKey(key).then(function (resp) {
    return resp.data;
  });
});